(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["scratch-compare-section"] && !Shopify.designMode) return;
  try {
    
/* No additional JavaScript is required for this section */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-scratch-icons-row"] && !Shopify.designMode) return;
  try {
    
/* No JavaScript is required for this section. */

  } catch(e) { console.error(e); }
})();
})();
